import { render, staticRenderFns } from "./KaiCard.vue?vue&type=template&id=b248bd3c&scoped=true&"
var script = {}
import style0 from "./KaiCard.vue?vue&type=style&index=0&id=b248bd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b248bd3c",
  null
  
)

export default component.exports